{
	"Keyword_Absorb": "Absorb",
	"Keyword_Affinity": "Affinity",
	"Keyword_Afflict": "Afflict",
	"Keyword_Afterlife": "Afterlife",
	"Keyword_Aftermath": "Aftermath",
	"Keyword_Amplify": "Amplify",
	"Keyword_Annihilator": "Annihilator",
	"Keyword_Ascend": "Ascend",
	"Keyword_Assist": "Assist",
	"Keyword_Augment": "Augment",
	"Keyword_Aura Swap": "Aura Swap",
	"Keyword_Awaken": "Awaken",
	"Keyword_Backup": "Backup",
	"Keyword_Banding": "Banding",
	"Keyword_Bargain": "Bargain",
	"Keyword_Basic landcycling": "Basic landcycling",
	"Keyword_Battle Cry": "Battle Cry",
	"Keyword_Bestow": "Bestow",
	"Keyword_Blitz": "Blitz",
	"Keyword_Bloodthirst": "Bloodthirst",
	"Keyword_Boast": "Boast",
	"Keyword_Bushido": "Bushido",
	"Keyword_Buyback": "Buyback",
	"Keyword_Cascade": "Cascade",
	"Keyword_Casualty": "Casualty",
	"Keyword_Champion": "Champion",
	"Keyword_Changeling": "Changeling",
	"Keyword_Choose a background": "Choose a background",
	"Keyword_Cipher": "Cipher",
	"Keyword_Cleave": "Cleave",
	"Keyword_Commander ninjutsu": "Commander ninjutsu",
	"Keyword_Companion": "Companion",
	"Keyword_Compleated": "Compleated",
	"Keyword_Conspire": "Conspire",
	"Keyword_Convoke": "Convoke",
	"Keyword_Craft": "Craft",
	"Keyword_Crew": "Crew",
	"Keyword_Cumulative upkeep": "Cumulative upkeep",
	"Keyword_Cycling": "Cycling",
	"Keyword_Dash": "Dash",
	"Keyword_Daybound": "Daybound",
	"Keyword_Deathtouch": "Deathtouch",
	"Keyword_Decayed": "Decayed",
	"Keyword_Defender": "Defender",
	"Keyword_Delve": "Delve",
	"Keyword_Demonstrate": "Demonstrate",
	"Keyword_Desertwalk": "Desertwalk",
	"Keyword_Dethrone": "Dethrone",
	"Keyword_Devoid": "Devoid",
	"Keyword_Devour": "Devour",
	"Keyword_Disguise": "Disguise",
	"Keyword_Disturb": "Disturb",
	"Keyword_Doctor's companion": "Doctor's companion",
	"Keyword_Double agenda": "Double agenda",
	"Keyword_Double strike": "Double strike",
	"Keyword_Double team": "Double team",
	"Keyword_Dredge": "Dredge",
	"Keyword_Echo": "Echo",
	"Keyword_Embalm": "Embalm",
	"Keyword_Emerge": "Emerge",
	"Keyword_Enchant": "Enchant",
	"Keyword_Encore": "Encore",
	"Keyword_Enlist": "Enlist",
	"Keyword_Entwine": "Entwine",
	"Keyword_Epic": "Epic",
	"Keyword_Equip": "Equip",
	"Keyword_Escalate": "Escalate",
	"Keyword_Escape": "Escape",
	"Keyword_Eternalize": "Eternalize",
	"Keyword_Evoke": "Evoke",
	"Keyword_Evolve": "Evolve",
	"Keyword_Exalted": "Exalted",
	"Keyword_Exhaust": "Exhaust",
	"Keyword_Exploit": "Exploit",
	"Keyword_Extort": "Extort",
	"Keyword_Fabricate": "Fabricate",
	"Keyword_Fading": "Fading",
	"Keyword_Fear": "Fear",
	"Keyword_Firebending": "Firebending",
	"Keyword_First strike": "First strike",
	"Keyword_Flanking": "Flanking",
	"Keyword_Flash": "Flash",
	"Keyword_Flashback": "Flashback",
	"Keyword_Flying": "Flying",
	"Keyword_For Mirrodin!": "For Mirrodin!",
	"Keyword_Forecast": "Forecast",
	"Keyword_Forestcycling": "Forestcycling",
	"Keyword_Forestwalk": "Forestwalk",
	"Keyword_Foretell": "Foretell",
	"Keyword_Fortify": "Fortify",
	"Keyword_Freerunning": "Freerunning",
	"Keyword_Frenzy": "Frenzy",
	"Keyword_Friends forever": "Friends forever",
	"Keyword_Fuse": "Fuse",
	"Keyword_Gift": "Gift",
	"Keyword_Graft": "Graft",
	"Keyword_Gravestorm": "Gravestorm",
	"Keyword_Harmonize": "Harmonize",
	"Keyword_Haste": "Haste",
	"Keyword_Haunt": "Haunt",
	"Keyword_Hexproof": "Hexproof",
	"Keyword_Hexproof from": "Hexproof from",
	"Keyword_Hidden agenda": "Hidden agenda",
	"Keyword_Hideaway": "Hideaway",
	"Keyword_Horsemanship": "Horsemanship",
	"Keyword_Impending": "Impending",
	"Keyword_Improvise": "Improvise",
	"Keyword_Indestructible": "Indestructible",
	"Keyword_Infect": "Infect",
	"Keyword_Ingest": "Ingest",
	"Keyword_Intensity": "Intensity",
	"Keyword_Intimidate": "Intimidate",
	"Keyword_Islandcycling": "Islandcycling",
	"Keyword_Islandwalk": "Islandwalk",
	"Keyword_Job select": "Job select",
	"Keyword_Jump-start": "Jump-start",
	"Keyword_Kicker": "Kicker",
	"Keyword_Landcycling": "Landcycling",
	"Keyword_Landwalk": "Landwalk",
	"Keyword_Legendary landwalk": "Legendary landwalk",
	"Keyword_Level Up": "Level Up",
	"Keyword_Lifelink": "Lifelink",
	"Keyword_Living metal": "Living metal",
	"Keyword_Living weapon": "Living weapon",
	"Keyword_Madness": "Madness",
	"Keyword_Max speed": "Max speed",
	"Keyword_Mayhem": "Mayhem",
	"Keyword_Megamorph": "Megamorph",
	"Keyword_Melee": "Melee",
	"Keyword_Menace": "Menace",
	"Keyword_Mentor": "Mentor",
	"Keyword_Miracle": "Miracle",
	"Keyword_Mobilize": "Mobilize",
	"Keyword_Modular": "Modular",
	"Keyword_More Than Meets the Eye": "More Than Meets the Eye",
	"Keyword_Morph": "Morph",
	"Keyword_Mountaincycling": "Mountaincycling",
	"Keyword_Mountainwalk": "Mountainwalk",
	"Keyword_Multikicker": "Multikicker",
	"Keyword_Mutate": "Mutate",
	"Keyword_Myriad": "Myriad",
	"Keyword_Nightbound": "Nightbound",
	"Keyword_Ninjutsu": "Ninjutsu",
	"Keyword_Nonbasic landwalk": "Nonbasic landwalk",
	"Keyword_Offering": "Offering",
	"Keyword_Offspring": "Offspring",
	"Keyword_Outlast": "Outlast",
	"Keyword_Overload": "Overload",
	"Keyword_Partner": "Partner",
	"Keyword_Partner with": "Partner with",
	"Keyword_Persist": "Persist",
	"Keyword_Phasing": "Phasing",
	"Keyword_Plainscycling": "Plainscycling",
	"Keyword_Plainswalk": "Plainswalk",
	"Keyword_Poisonous": "Poisonous",
	"Keyword_Protection": "Protection",
	"Keyword_Prototype": "Prototype",
	"Keyword_Provoke": "Provoke",
	"Keyword_Prowess": "Prowess",
	"Keyword_Prowl": "Prowl",
	"Keyword_Rampage": "Rampage",
	"Keyword_Ravenous": "Ravenous",
	"Keyword_Reach": "Reach",
	"Keyword_Read Ahead": "Read Ahead",
	"Keyword_Rebound": "Rebound",
	"Keyword_Reconfigure": "Reconfigure",
	"Keyword_Recover": "Recover",
	"Keyword_Reinforce": "Reinforce",
	"Keyword_Renown": "Renown",
	"Keyword_Replicate": "Replicate",
	"Keyword_Retrace": "Retrace",
	"Keyword_Riot": "Riot",
	"Keyword_Ripple": "Ripple",
	"Keyword_Saddle": "Saddle",
	"Keyword_Scavenge": "Scavenge",
	"Keyword_Shadow": "Shadow",
	"Keyword_Shroud": "Shroud",
	"Keyword_Skulk": "Skulk",
	"Keyword_Slivercycling": "Slivercycling",
	"Keyword_Soulbond": "Soulbond",
	"Keyword_Soulshift": "Soulshift",
	"Keyword_Specialize": "Specialize",
	"Keyword_Spectacle": "Spectacle",
	"Keyword_Splice": "Splice",
	"Keyword_Split second": "Split second",
	"Keyword_Spree": "Spree",
	"Keyword_Squad": "Squad",
	"Keyword_Station": "Station",
	"Keyword_Storm": "Storm",
	"Keyword_Sunburst": "Sunburst",
	"Keyword_Surge": "Surge",
	"Keyword_Suspend": "Suspend",
	"Keyword_Swampcycling": "Swampcycling",
	"Keyword_Swampwalk": "Swampwalk",
	"Keyword_Toxic": "Toxic",
	"Keyword_Training": "Training",
	"Keyword_Trample": "Trample",
	"Keyword_Transfigure": "Transfigure",
	"Keyword_Transmute": "Transmute",
	"Keyword_Tribute": "Tribute",
	"Keyword_Typecycling": "Typecycling",
	"Keyword_Umbra armor": "Umbra armor",
	"Keyword_Undaunted": "Undaunted",
	"Keyword_Undying": "Undying",
	"Keyword_Unearth": "Unearth",
	"Keyword_Unleash": "Unleash",
	"Keyword_Vanishing": "Vanishing",
	"Keyword_Vigilance": "Vigilance",
	"Keyword_Ward": "Ward",
	"Keyword_Warp": "Warp",
	"Keyword_Web-slinging": "Web-slinging",
	"Keyword_Wither": "Wither",
	"Keyword_Wizardcycling": "Wizardcycling"
}